/**
 * Constantes para o componente Result Monetary
 */

/**
 * Ícones para valores monetários baseados no contexto
 */
export const MONETARY_ICONS: { [key: string]: string } = {
    'dizimo': '💰',
    'dizimos': '💰',
    'oferta': '🎁',
    'ofertas': '🎁',
    'entrada': '📥',
    'entradas': '📥',
    'saida': '📤',
    'saidas': '📤',
    'saldo': '🏦',
    'total': '💵',
    'valor': '💵',
    'receita': '📈',
    'despesa': '📉',
    'default': '💵'
};

/**
 * Obtém o ícone baseado no título
 */
export function getMonetaryIcon(title: string): string {
    const lowerTitle = title.toLowerCase();

    for (const [key, icon] of Object.entries(MONETARY_ICONS)) {
        if (lowerTitle.includes(key)) {
            return icon;
        }
    }

    return MONETARY_ICONS['default'];
}

/**
 * Formata valor para moeda brasileira
 */
export function formatCurrencyBRL(value: number | string): string {
    const numValue = typeof value === 'string' ? parseFloat(value) : value;

    if (isNaN(numValue)) {
        return String(value);
    }

    return numValue.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL'
    });
}
